export type PhoneIconProps = {
  width: string | number;
  height: string | number;
  color?: string;
};

const PhoneIcon = ({ width, height, color }: PhoneIconProps) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 57 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="phone">
          <path
            id="Vector"
            d="M51.6634 39.4801V46.4801C51.6661 47.1299 51.5329 47.7731 51.2726 48.3685C51.0123 48.964 50.6304 49.4984 50.1516 49.9377C49.6727 50.3771 49.1074 50.7115 48.4918 50.9197C47.8762 51.1279 47.224 51.2052 46.5767 51.1467C39.3967 50.3666 32.4997 47.9131 26.4401 43.9834C20.8023 40.4009 16.0225 35.6211 12.4401 29.9834C8.4967 23.8962 6.04265 16.9657 5.27675 9.7534C5.21844 9.10815 5.29513 8.45784 5.50192 7.84385C5.70871 7.22987 6.04108 6.66567 6.47787 6.18718C6.91466 5.70869 7.4463 5.32639 8.03893 5.06461C8.63156 4.80284 9.27221 4.66734 9.92009 4.66673H16.9201C18.0525 4.65559 19.1503 5.05658 20.0089 5.79497C20.8675 6.53337 21.4283 7.55877 21.5868 8.68006C21.8822 10.9202 22.4301 13.1198 23.2201 15.2367C23.534 16.0719 23.602 16.9795 23.4159 17.8521C23.2298 18.7247 22.7974 19.5257 22.1701 20.1601L19.2068 23.1234C22.5284 28.965 27.3651 33.8018 33.2068 37.1234L36.1701 34.1601C36.8045 33.5327 37.6054 33.1004 38.478 32.9143C39.3506 32.7282 40.2583 32.7961 41.0934 33.1101C43.2104 33.9 45.4099 34.4479 47.6501 34.7434C48.7835 34.9033 49.8187 35.4742 50.5587 36.3476C51.2986 37.2209 51.6918 38.3357 51.6634 39.4801Z"
            fill={color ?? "currentColor"}
          />
        </g>
      </svg>
    </>
  );
};

export default PhoneIcon;
